
import React from 'react';
import { Database, AlertCircle, WifiOff } from 'lucide-react';

interface DataEmptyStateProps {
  error: string | null;
  status?: string | null;
}

const DataEmptyState: React.FC<DataEmptyStateProps> = ({ error, status }) => {
  // Generate appropriate message and icon based on connection status
  let message = error || 'No data available';
  let icon = <Database className="h-12 w-12 text-gray-400 mx-auto mb-4" />;
  let title = 'Data Not Available';

  if (status === 'incomplete') {
    message = 'This connection is not completed. Please complete the setup to view data.';
    icon = <AlertCircle className="h-12 w-12 text-amber-400 mx-auto mb-4" />;
    title = 'Connection Incomplete';
  } else if (status === 'broken') {
    message = 'This connection is broken. Please reconnect to view data.';
    icon = <WifiOff className="h-12 w-12 text-red-400 mx-auto mb-4" />;
    title = 'Connection Broken';
  }

  return (
    <div className="border rounded-lg p-8 text-center bg-gray-50" data-testid="data-empty-state">
      {icon}
      <h3 className="text-lg font-medium text-gray-700 mb-2">{title}</h3>
      <p className="text-gray-600 mb-4">{message}</p>
    </div>
  );
};

export default DataEmptyState;
